import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ConsentMorePage } from 'src/app/model/page/consent-more-info-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-consent-moreinfo-page',
  templateUrl: './consent-moreinfo-page.component.html',
  styleUrls: ['./consent-moreinfo-page.component.scss']
})
export class ConsentMoreinfoPageComponent implements OnInit {
  ConsentSectionCard: ConsentMorePage[] = [];
  ConsentMorePage: ConsentMorePage = {} as ConsentMorePage;

  constructor(private contentfulService: ContentfulService) {}
  ngOnInit() {
    htmlTitle.filter((title) => {
      if (title.page === 'ConsentMorePage') {
        this.ConsentMorePage.htmlTitle = title.htmlTitle;
      }
    });

    const query = { 'fields.title': 'Consent More information' };
    this.contentfulService.getPageContentResponse(query).then((consentMoreInfoPageEntries) => {
      this.mapBanners(consentMoreInfoPageEntries.includes.Entry);

      this.mapHtmlTitle(consentMoreInfoPageEntries.items);
    });
  }

  private mapBanners(consentMoreInfoPageEntries: Entry<any>[]) {
    consentMoreInfoPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    this.ConsentMorePage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.ConsentMorePage.htmlTitle = entry.fields.htmlTitle;
      this.ConsentMorePage.belowBody = entry.fields.summary;
    });
  }
}
